<template>
    <el-select
        filterable
        clearable
        v-model="selected"
    >
        <el-option v-for="i in list" :key="i" :label="i" :value="i">                
                
                    <a ><span :class="i"></span></a>
                    <!-- <img :src="i" > -->
                   
        </el-option>
    </el-select>
</template>
<style lang="scss" scoped>
.el-select-dropdown__item {
    font-size: 14px;
    padding: 8px 10px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #48576a;
    height: 60px!important;
    line-height: 1.5;
    box-sizing: border-box;
    cursor: pointer;
    align-items:center!important;
}

</style>
<script>
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';

    export default {
        data: function () {
            return{
                selected: this.value,
                list: []
            }
        },
        components: {
            ElSelect,
            ElOption
        },
        props: ['value'],
        watch: {
            value: function (value) {
                this.selected = value;
            },
            selected: function (value) {
                this.$emit('input', value);
            }
        },
        mounted: function () {
            const set = new Set(['formcontact', 'telefono','movil', 'redes','sucursales','videoatencion']);
            this.list = Array.from(set);
        }
    }
</script>